import { useTranslation } from 'react-i18next'
import './ErrorPage.scss'

const MaintenancePage = ({ message }) => {
  const { t } = useTranslation('common')

  return (
    <div className="error-page">
      <div className="error-page__card">
        <div className="error-page__code">&#x1F527;</div>
        <h1 className="error-page__title">{t('errors.maintenanceTitle')}</h1>
        <p className="error-page__message">
          {message || t('errors.maintenanceDefaultMessage')}
        </p>
      </div>
    </div>
  )
}

export default MaintenancePage
